<ng-container *ngIf="!menuapp">
	<form [formGroup]="searchForm" class="m-0 p-0">
		<div class="main_card m-0 p-0">
			<div class="row m-0 p-0">
				<div class="col-12">
					<h3> Sales Trends 8 week (Top 100 items)</h3>
				</div>
			</div>
			<div class="row m-0 p-0">
				<!-- <div class="col-xs-12 col-md-3 col-3">
					<mat-form-field appearance="outline" class="amount-text">
						<mat-label>Limit</mat-label>
						<input matInput type="text" formControlName="limit" class="text-right " />
					</mat-form-field>
				</div> -->
				<div class="col-xs-12 col-md-3 col-3">
					<span *ngIf="sending">
						<svg class="spinner" width="35px" height="35px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
							<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
						</svg>
					</span>
					&nbsp;&nbsp; <button class="btn btn-success btn-sm" (click)="$event.preventDefault();exportXls()" *ngIf="!sending">
						<i class="fa fa-file-excel-o"></i> XLS
					</button>
					&nbsp;&nbsp;
					<button class="btn btn-danger btn-sm" (click)="$event.preventDefault();exportPdf()" *ngIf="!sending">
						<i class="fa fa-file-pdf-o"></i> PDF
					</button>
					&nbsp;&nbsp;
					<button mat-raised-button color="accent" class="mt-2" (click)="getData()" *ngIf="!sending">
						<mat-icon>refresh</mat-icon>
					</button>
				</div>
			</div>
		</div>
	</form>
	<div #print_table class="m-0 p-0 card shadow-sm rounded-3 border-0">

	  <!-- Summary Cards -->
	  <div class="row m-0 p-3 g-3 mb-4" *ngIf="summary && reportResults && reportResults.length > 0">
		<div class="col-md-3 col-sm-6">
		  <div class="stat-card stat-card-primary">
			<div class="stat-card-icon">
			  <i class="fa fa-cubes"></i>
			</div>
			<div class="stat-card-content">
			  <div class="stat-card-label">Total Products</div>
			  <div class="stat-card-value">{{ reportResults?.length || 0 | number }}</div>
			</div>
		  </div>
		</div>
		<div class="col-md-3 col-sm-6">
		  <div class="stat-card stat-card-success">
			<div class="stat-card-icon">
			  <i class="fa fa-dollar"></i>
			</div>
			<div class="stat-card-content">
			  <div class="stat-card-label">Total Sales</div>
			  <div class="stat-card-value">{{ getTotalSales() | currency }}</div>
			</div>
		  </div>
		</div>
		<div class="col-md-3 col-sm-6">
		  <div class="stat-card stat-card-info">
			<div class="stat-card-icon">
			  <i class="fa fa-shopping-cart"></i>
			</div>
			<div class="stat-card-content">
			  <div class="stat-card-label">Total Quantity</div>
			  <div class="stat-card-value">{{ getTotalQuantity() | number }}</div>
			</div>
		  </div>
		</div>
		<div class="col-md-3 col-sm-6">
		  <div class="stat-card stat-card-warning">
			<div class="stat-card-icon">
			  <i class="fa fa-tag"></i>
			</div>
			<div class="stat-card-content">
			  <div class="stat-card-label">Avg Price</div>
			  <div class="stat-card-value">{{ getAveragePrice() | currency }}</div>
			</div>
		  </div>
		</div>
	  </div>

	  <!-- Trend Insights -->
	  <div class="row m-0 p-3 mb-3" *ngIf="reportResults && reportResults.length > 0">
		<div class="col-md-4">
		  <div class="alert alert-info d-flex align-items-center">
			<i class="fa fa-arrow-up me-2"></i>
			<div>
			  <strong>Growing Trends:</strong> {{ getGrowingTrendsCount() }} products showing upward momentum
			</div>
		  </div>
		</div>
		<div class="col-md-4">
		  <div class="alert alert-warning d-flex align-items-center">
			<i class="fa fa-exclamation-triangle me-2"></i>
			<div>
			  <strong>Trial Products:</strong> {{ getTrialSpikesCount() }} products with one-time spikes
			</div>
		  </div>
		</div>
		<div class="col-md-4">
		  <div class="alert alert-success d-flex align-items-center">
			<i class="fa fa-check-circle me-2"></i>
			<div>
			  <strong>Stable Products:</strong> {{ getStableTrendsCount() }} products with consistent patterns
			</div>
		  </div>
		</div>
	  </div>

	  <!-- Quick Insights -->
	  <!-- <div class="row g-3 mb-4" *ngIf="summary">
		<div class="col-md-6">
		  <div class="alert alert-warning">
			<strong>Trial Behavior:</strong>
			{{ summary.trial_behavior_count }} SKUs had a one-time spike.
		  </div>
		</div>
		<div class="col-md-6">
		  <div class="alert alert-secondary">
			<strong>Repeat Behavior:</strong>
			{{ summary.repeat_behavior_count }} SKUs show consistent purchasing patterns.
		  </div>
		</div>
	  </div> -->

	  <!-- Report Table -->
	  <div class="card-body m-0 p-0">
		<div class="table-responsive">
		  <table class="table table-striped table-hover table-bordered align-middle text-center m-0">
			<!-- <thead class="thead-dark">
			  <tr>
				<th (click)="sortBy('stockid')" class="cursor-pointer">Item #</th>
				<th (click)="sortBy('description')" class="cursor-pointer text-start">Description</th>
				<th (click)="sortBy('salestotal')" class="cursor-pointer">Total Sales</th>
				<th (click)="sortBy('qtytotal')" class="cursor-pointer">Qty</th>
				<th (click)="sortBy('frequency')" class="cursor-pointer">Frequency</th>
				<th (click)="sortBy('trend_label')" class="cursor-pointer">Trend</th>
				<th (click)="sortBy('avg_weekly')" class="cursor-pointer">Avg/Wk</th>
				<th (click)="sortBy('one_time_spike')" class="cursor-pointer">Trial?</th>
				<th (click)="sortBy('action_recommendation')" class="cursor-pointer">Recommended Action</th>
			  </tr>
			</thead> -->
			<!-- <tbody>
			  <tr *ngFor="let r of sortedReportResults">
				<td class="fw-semibold">{{ r.stockid }}</td>
				<td class="text-start">{{ r.description }}</td>
				<td>{{ r.salestotal | currency }}</td>
				<td>{{ r.qtytotal | number }}</td>
				<td>{{ r.frequency }}</td>
				<td>
				  <span class="badge px-2 py-1"
					[ngClass]="{
					  'bg-success text-light': r.trend_label === 'Stable',
					  'bg-warning text-dark': r.trend_label === 'Low Activity',
					  'bg-danger text-light': r.trend_label === 'One-Time Spike',
					  'bg-primary': r.trend_label === 'Upward',
					  'bg-info text-dark': r.trend_label === 'Spike',
					  'bg-dark': r.trend_label === 'Downward',
					  'bg-secondary': r.trend_label === 'Volatile'
					}">
					{{ r.trend_label }}
				  </span>
				</td>
				<td>{{ r.avg_weekly | number:'1.2-2' }}</td>
				<td>
				  <span class="badge rounded-pill px-3"
					[ngClass]="{
					  'bg-danger text-light': r.one_time_spike,
					  'bg-secondary': !r.one_time_spike
					}">
					{{ r.one_time_spike ? 'Yes' : 'No' }}
				  </span>
				</td>
				<td>
				  <span class="badge px-2"
					[ngClass]="{
					  'bg-secondary': r.action_recommendation.startsWith('Monitor'),
					  'bg-success text-light': r.action_recommendation.startsWith('High Growth'),
					  'bg-info text-dark': r.action_recommendation.startsWith('Reliable Buyer'),
					  'bg-warning text-dark': r.action_recommendation.includes('Low'),
					  'bg-danger text-light': r.action_recommendation.includes('Spike') || r.action_recommendation.includes('Falling') || r.action_recommendation.includes('Unstable')
					}">
					{{ r.action_recommendation }}
				  </span>
				</td>
			  </tr>
			</tbody> -->
			<thead class="thead-dark">
			  <tr>
				<th (click)="sortBy('stockid')" class="cursor-pointer">
				  Item #
				  <i class="fa sort-icon" [ngClass]="getSortIcon('stockid')"></i>
				</th>
				<th (click)="sortBy('description')" class="cursor-pointer text-start">
				  Description
				  <i class="fa sort-icon" [ngClass]="getSortIcon('description')"></i>
				</th>
				<th (click)="sortBy('salestotal')" class="cursor-pointer">
				  Total Sales
				  <i class="fa sort-icon" [ngClass]="getSortIcon('salestotal')"></i>
				</th>
				<th (click)="sortBy('qtytotal')" class="cursor-pointer">
				  Quantity
				  <i class="fa sort-icon" [ngClass]="getSortIcon('qtytotal')"></i>
				</th>
				<th (click)="sortBy('frequency')" class="cursor-pointer">
				  Frequency
				  <i class="fa sort-icon" [ngClass]="getSortIcon('frequency')"></i>
				</th>
				<th (click)="sortBy('avg_price')" class="cursor-pointer">
				  Avg Price
				  <i class="fa sort-icon" [ngClass]="getSortIcon('avg_price')"></i>
				</th>
				<th (click)="sortBy('slope')" class="cursor-pointer">
				  Trend
				  <i class="fa sort-icon" [ngClass]="getSortIcon('slope')"></i>
				</th>
				<th (click)="sortBy('volatility')" class="cursor-pointer">
				  Volatility
				  <i class="fa sort-icon" [ngClass]="getSortIcon('volatility')"></i>
				</th>
				<th (click)="sortBy('one_time_spike')" class="cursor-pointer">Trial?</th>
			  </tr>
			</thead>
			<tbody>
			  <tr *ngFor="let r of sortedReportResults" [ngClass]="getRowClass(r)">
				<td class="fw-semibold">{{ r.stockid }}</td>
				<td class="text-start">{{ r.description }}</td>
				<td class="fw-bold">{{ r.salestotal | currency }}</td>
				<td>{{ r.qtytotal | number }}</td>
				<td>
				  <span class="badge bg-primary">{{ r.frequency }}</span>
				</td>
				<td>{{ r.avg_price | currency }}</td>
				<td>
				  <span class="badge px-2 py-1" [ngClass]="getTrendBadgeClass(r.slope)">
					<i class="fa" [ngClass]="getTrendIcon(r.slope)"></i>
					{{ r.slope | number:'1.2-2' }}
				  </span>
				</td>
				<td>
				  <span class="badge px-2 py-1" [ngClass]="getVolatilityBadgeClass(r.volatility)">
					{{ r.volatility | number:'1.2-2' }}
				  </span>
				</td>
				<td>
				  <span class="badge rounded-pill px-3"
					[ngClass]="{
					  'bg-danger text-light': r.one_time_spike,
					  'bg-secondary text-light': !r.one_time_spike
					}">
					{{ r.one_time_spike ? 'Yes' : 'No' }}
				  </span>
				</td>
			  </tr>
			</tbody>
		  </table>

		  <!-- Spinner -->
		  <div class="d-flex justify-content-center p-4" *ngIf="loading">
			<svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66"
				 xmlns="http://www.w3.org/2000/svg">
			  <circle class="path" fill="none" stroke-width="6"
					  stroke-linecap="round" cx="33" cy="33" r="30"></circle>
			</svg>
		  </div>
		</div>
	  </div>
	</div>

</ng-container>
